import { PatientTabProps } from '~/lib/constants/patients.constants';

import InquiryEnrollment from '../inquiryEnrollment';

const PatientEnrollmentTab = (patientTabProps: PatientTabProps) => (
  <InquiryEnrollment {...patientTabProps} />
);

export default PatientEnrollmentTab;
